import { Button, styled } from '@mui/material';

export const PageW = styled('div')`
  width: 100%;
  padding-left: 38px;
  padding-top: 64px;
  @media (max-width: 1023px) {
    padding: 88px 16px 96px 16px;
  }
`;

export const HeaderW = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ContentW = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ButtonW = styled(Button)`
  display: none;
  text-transform: none;
  margin-top: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  @media (max-width: 1023px) {
    display: inline-flex;
    justify-content: flex-start;
  }
`;
